import type { JSX } from "react";

import { Button, Group, Text } from "@mantine/core";

import type { VoiceTask } from "@/sdk";

import { ArrowRectangleDown, ArrowRectangleUp, PhoneNumber } from "@/common-ui";

import { useIsPacingActive } from "../../hooks/useIsPacingActive";
import { getConferenceCallersCount } from "../../utils";
import { useControlsStore } from "../controls.store";
import { CallDuration } from "./CallDuration";
import classes from "./StandardCallBar.module.css";

interface CallBarProps {
    task: VoiceTask;
}

export function StandardCallBar({ task }: CallBarProps): JSX.Element {
    const { isConference, conferencePanelOpen, toggleConferencePanelOpen } = useControlsStore();
    const isPacingActive = useIsPacingActive();

    const conferenceCallersCount = getConferenceCallersCount(task);
    const conferenceCallersCountText = conferenceCallersCount > 1 ? "participants" : "participant";
    return (
        <Group gap="0" wrap={"nowrap"}>
            {isConference ? (
                <Button
                    classNames={{ root: classes.conferenceButtonRoot, section: classes.conferenceButtonSection }}
                    data-testid="call-controls-conference-toggle"
                    variant="transparent"
                    pl="0"
                    pr="xs"
                    color="white"
                    size="xs"
                    onClick={toggleConferencePanelOpen}
                    rightSection={conferencePanelOpen ? <ArrowRectangleUp /> : <ArrowRectangleDown />}
                >
                    <Text fw={700} size="sm" td="underline">
                        {conferenceCallersCount} {conferenceCallersCountText}
                    </Text>
                </Button>
            ) : (
                <Text className="fs-mask" fw={700} mr="sm" size="sm" lineClamp={1}>
                    <PhoneNumber mdn={task.callerId} />
                </Text>
            )}
            {/*
              Pacing pilot moves the call timer next to the action buttons (rendered in
              CallControls.tsx). Non-pilot experts keep the legacy position next to the
              phone number, so we only render here when the pacing pilot is NOT active.
            */}
            {task.status === "assigned" && !isPacingActive ? <CallDuration task={task} /> : null}
        </Group>
    );
}
